<section class="title-bar content-padding first-item">
  <div class="wrapper">
    <h2 class="left">Profilo</h2>
    <br class="clear">
  </div>
</section>

<app-expert-form *ngIf="group == 'expert'" profile="true"></app-expert-form>
<app-partner-form *ngIf="group == 'partner'" profile="true"></app-partner-form>
<app-admin-form *ngIf="group == 'admin'" profile="true"></app-admin-form>
<app-operation-form *ngIf="group == 'operation'" profile="true"></app-operation-form>
<app-team-leader-form *ngIf="group == 'teamleader'" profile="true"></app-team-leader-form>
